import { useContext } from 'react';
import { useMutation } from 'react-query';
import { axiosApiInstance, axios, qs } from '../lib';
import { AuthContext } from '../context/AuthContext';

const defaultConfig = {
  params: {},
  preventDataValidation: false,
  requestType: 'post',
  axiosInstance: axiosApiInstance,
};

const defaultQueryFn = async (
  instance,
  method,
  url,
  params,
  preventDataValidation
) => {
  const response = await instance[method](url, params);

  const isValid = preventDataValidation
    ? response?.data
    : response?.data.status;

  if (isValid) {
    return (
      response?.data?.Result?.Rows ||
      response?.data?.Result?.rows ||
      response?.data?.Result ||
      response?.data
    );
  }

  throw new Error(`errors.api.${response?.data?.Message}`);
};

const useAxiosMutation = (config) => {
  const { token: userToken } = useContext(AuthContext);
  const finalConfig = { ...defaultConfig, ...config };

  return useMutation(
    [finalConfig.url, finalConfig.params],
    (p) => {
      const otherParams = {
        token: userToken,
        ...finalConfig.params,
      };

      let req;
      if (
        finalConfig.requestType === 'get' &&
        !(p instanceof URLSearchParams)
      ) {
        delete otherParams.token;
        const sParams = new URLSearchParams();
        const merged = {
          ...otherParams,
          ...p,
        };
        Object.keys(merged).forEach((key) => {
          sParams.append(key, merged[key]);
        });
        req = { params: sParams };
      } else if (
        finalConfig.requestType === 'get' &&
        p instanceof URLSearchParams
      ) {
        delete otherParams.token;
        Object.keys(otherParams).forEach((key) => {
          p.append(key, otherParams[key]);
        });
        req = { params: p };
      } else if (p instanceof FormData) {
        Object.keys(otherParams).forEach((key) => {
          p.append(key, otherParams[key]);
        });
        req = p;
      } else {
        req = qs.stringify({
          ...otherParams,
          ...p,
        });
      }

      let staticAxios = finalConfig.axiosInstance;
      if (
        finalConfig.url.indexOf('http://') === 0 ||
        finalConfig.url.indexOf('https://') === 0
      ) {
        staticAxios = axios;
      }

      return defaultQueryFn(
        staticAxios,
        finalConfig.requestType,
        finalConfig.url,
        req,
        finalConfig.preventDataValidation
      );
    },
    {
      retry: false,
      onSuccess: finalConfig.onSuccess,
      onError: finalConfig.onError,
    }
  );
};

export default useAxiosMutation;
